import { Controller } from "@hotwired/stimulus"

// Opens a release screenshot in a native dialog. Escape closes it.
export default class extends Controller {
  static targets = [ "dialog", "full" ]

  disconnect() {
    if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close()
  }

  open(event) {
    event.preventDefault()
    this.fullTarget.src = event.params.src
    this.fullTarget.alt = event.params.alt
    this.dialogTarget.showModal()
  }

  close(event) {
    event.preventDefault()
    this.dialogTarget.close()
  }

  backdrop(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }
}
